import { createSyncGuestOrderStore } from '@bonboca/shared-domain';

export type { GuestOrderEntry } from '@bonboca/shared-domain';

const store =
  typeof window !== 'undefined'
    ? createSyncGuestOrderStore(window.localStorage)
    : createSyncGuestOrderStore({ getItem: () => null, setItem: () => {} });

export const rememberGuestOrder = store.rememberGuestOrder;
export const listRememberedGuestOrders = store.listRememberedGuestOrders;
export const getStoredGuestOrderToken = store.getStoredGuestOrderToken;
export const forgetGuestOrder = store.forgetGuestOrder;
